<div class="upload-container">
  <label>

    <input #inputField type="file" accept="image/jpeg, image/pjpeg, image/png"
      (change)="fileSelected($event)" (click)="inputField.value = ''" />

    <div class="image-preview">
      <img [src]="src" alt="">
    </div>

  </label>
</div>
